export default __webpack_public_path__ + "static/media/tapaOtono22_3.40ba1140.jpg";